// @flow
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import HomeLayout from '../../components/HomeLayout';
import { GrayContainer } from '../../components/ui/containers';
import { Row, Column } from '../../components/ui/layout';
import CityViewer from '../../components/CityViewer';
import ContactForm from './ContactForm';


const Title = styled.h2`
  color: white;
  font-size: 24px;
  font-weight: 700;
`;

const ContactInfo = styled.div`
  border-top: 1px solid #333;
  border-bottom: 1px solid #333;
  font-size: 14px;
`;

const Container = GrayContainer.extend`
  flex-direction: column;
  color: white;
  padding-bottom: 30px;
`;

const ContactData = styled.div`
  font-size: 14px;
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ContactColumn = Column.extend`
  border-right: 1px solid #333;
  padding: 10px;
  align-content: center;

  &:first-child {
    text-align: right;
  }
  &:last-child {
    border-right: none;
  }
`;


class Contact extends PureComponent {
  props: {
    clientInfo: Object,
    pageInfo: Object,
  }

  render() {
    const { clientInfo = {}, pageInfo = {} } = this.props;
    return (
      <HomeLayout>
        <Container>
          <Title>Contáctenos</Title>
          <ContactInfo>
            <Row>
              <ContactColumn flex={1}>
                <ContactData>{clientInfo.address}</ContactData>
                <ContactData>
                  {clientInfo.city && <CityViewer idOrName={clientInfo.city} />}
                  <span>, </span>
                  {clientInfo.country_name && <span>{clientInfo.country_name}</span>}
                </ContactData>
              </ContactColumn>
              {pageInfo.contact && (
                <ContactColumn flex={1}>
                  <ContactData>
                    {pageInfo.contact.phone_label1}: {pageInfo.contact.phone1}
                  </ContactData>
                  <ContactData>
                    {pageInfo.contact.phone_label2}: {pageInfo.contact.phone2}
                  </ContactData>
                </ContactColumn>
              )}
            </Row>
          </ContactInfo>
          <ContactForm />
        </Container>
      </HomeLayout>
    )
  }
}

export default connect(state => ({
  clientInfo: state.client.info,
  pageInfo: state.client.pageInfo,
}))(Contact);



// WEBPACK FOOTER //
// ./src/routes/Contact/index.js